import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Mousewheel } from "swiper/modules";
import clsx from "clsx";
import { LINEAR_GRADIENT_TEXTS } from "../constants/main";
import { mousewheel } from "../App";

const Section5 = ({ onSlideChange }) => {
  return (
    <Swiper
      className="text_animation_box"
      direction="vertical"
      mousewheel={mousewheel}
      nested
      effect="fade"
      speed={0}
      preventInteractionOnTransition
      modules={[EffectFade, Mousewheel]}
      onSlideChange={onSlideChange}
    >
      {[0, 1, 2, 3, 4].map((index) => (
        <SwiperSlide key={`text_animation_${index}`}>
          <div className="container">
            <div className="text_box">
              {LINEAR_GRADIENT_TEXTS.map((text, i) => (
                <p
                  key={text}
                  data-text={text}
                  className={clsx("text", {
                    active: index > i + 1,
                    animate: index === i + 1,
                  })}
                >
                  {text}
                </p>
              ))}
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Section5;
